import { render, staticRenderFns } from "./CarbonSegmentImport.vue?vue&type=template&id=4b4e67a1&"
import script from "./CarbonSegmentImport.vue?vue&type=script&lang=js&"
export * from "./CarbonSegmentImport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports